import React from 'react';
import { useRouter } from 'next/router';
import NotFoundContainer from 'app/components/ErrorHandler/NotFoundContainer';
import SendStatistics from 'app/components/CommonElements/SendStatistics';
import { errorStatistics } from 'app/utils/statistics/universalStatistics';

const NotFound = () => {
    const router = useRouter();

    return (
        <>
            <NotFoundContainer baseContainer shouldDispatchHttpStatus />
            {typeof window !== 'undefined' && (
                <SendStatistics
                    statisticsObject={errorStatistics(500, router.asPath)}
                />
            )}
        </>
    );
};

export default NotFound;
